import { MuiAccordion, MuiAccordionActions, MuiAccordionDetails, MuiAccordionSummary } from './components/MuiAccordion'
import { MuiAlert } from './components/MuiAlert'
import { MuiAppBar } from './components/MuiAppBar'
import { MuiAutocomplete } from './components/MuiAutocomplete'
import { MuiAvatar, MuiAvatarGroup } from './components/MuiAvatar'
import { MuiBreadcrumbs } from './components/MuiBreadcrumbs'
import { MuiButton } from './components/MuiButton'
import { MuiButtonGroup } from './components/MuiButtonGroup'
import { MuiCard, MuiCardActionArea, MuiCardActions, MuiCardContent, MuiCardHeader, MuiCardMedia } from './components/MuiCard'
import { MuiCheckbox } from './components/MuiCheckbox'
import { MuiChip } from './components/MuiChip'
import { MuiCircularProgress } from './components/MuiCircularProgress'
import { MuiDataGrid } from './components/MuiDataGrid'
import {
  MuiDateCalendar,
  MuiDatePicker,
  MuiDayCalendar,
  MuiPickersCalendarHeader,
  MuiPickersDay,
  MuiPickersLayout,
  MuiPickersPopper,
  MuiPickersYear,
  MuiPickersArrowSwitcher,
  MuiDateRangePickerDay,
  MuiDateRangeCalendar,
} from './components/MuiDatePicker'
import { MuiDialog, MuiDialogActions, MuiDialogContent, MuiDialogContentText, MuiDialogTitle } from './components/MuiDialog'
import { MuiDivider } from './components/MuiDivider'
import { MuiDrawer } from './components/MuiDrawer'
import { MuiFab } from './components/MuiFab'
import { MuiFormControlLabel } from './components/MuiFormControlLabel'
import { MuiIconButton } from './components/MuiIconButton'
import { MuiLinearProgress } from './components/MuiLinearProgress'
import { MuiLink } from './components/MuiLink'
import { MuiListItem } from './components/MuiListItem'
import { MuiMenu, MuiMenuItem } from './components/MuiMenu'
import { MuiPaper } from './components/MuiPaper'
import { MuiPopover } from './components/MuiPopover'
import { MuiRadio } from './components/MuiRadio'
import { MuiSelect } from './components/MuiSelect'
import { MuiSwitch } from './components/MuiSwitch'
import {
  MuiTable,
  MuiTableBody,
  MuiTableCell,
  MuiTableContainer,
  MuiTableFooter,
  MuiTableHead,
  MuiTablePagination,
  MuiTableRow,
  MuiTableSortLabel,
} from './components/MuiTable'
import { MuiTab, MuiTabs } from './components/MuiTabs'
import {
  MuiFormHelperText,
  MuiInputBase,
  MuiInputLabel,
  MuiInput,
  MuiTextField,
  MuiInputAdornment,
  MuiFormLabel,
} from './components/MuiTextField'
import { MuiToggleButton } from './components/MuiToggleButton'
import { MuiTooltip } from './components/MuiTooltip'
import { MuiTreeItem } from './components/MuiTreeItem'
import { MuiTypography } from './components/MuiTypography'
import { OmuiChipWithActionButton } from './components/OmuiChipWithActionButton'
import { OmuiCountBadge } from './components/OmuiCountBadge'
import { OmuiNumberStepper } from './components/OmuiNumberStepper'
import { OmuiSegmentedControl } from './components/OmuiSegmentedControl'
import { OmuiStatusBar } from './components/OmuiStatusBar'

export const components = {
  MuiAccordion,
  MuiAccordionActions,
  MuiAccordionDetails,
  MuiAccordionSummary,
  MuiAlert,
  MuiAppBar,
  MuiAutocomplete,
  MuiAvatar,
  MuiAvatarGroup,
  MuiBreadcrumbs,
  MuiButton,
  MuiButtonGroup,
  MuiCard,
  MuiCardActionArea,
  MuiCardActions,
  MuiCardContent,
  MuiCardHeader,
  MuiCardMedia,
  MuiCheckbox,
  MuiChip,
  MuiDatePicker,
  MuiDateCalendar,
  MuiDayCalendar,
  MuiPickersArrowSwitcher,
  MuiPickersCalendarHeader,
  MuiPickersDay,
  MuiPickersLayout,
  MuiPickersPopper,
  MuiPickersYear,
  MuiDateRangePickerDay,
  MuiDateRangeCalendar,
  MuiDialog,
  MuiDialogActions,
  MuiDialogContent,
  MuiDialogContentText,
  MuiDialogTitle,
  MuiDivider,
  MuiDrawer,
  MuiFab,
  MuiFormControlLabel,
  MuiFormLabel,
  MuiIconButton,
  MuiInput,
  MuiInputAdornment,
  MuiTextField,
  MuiInputLabel,
  MuiFormHelperText,
  MuiInputBase,
  MuiCircularProgress,
  MuiLinearProgress,
  MuiLink,
  MuiListItem,
  MuiMenu,
  MuiMenuItem,
  MuiPaper,
  MuiSelect,
  MuiPopover,
  MuiRadio,
  MuiSwitch,
  MuiTab,
  MuiTabs,
  MuiToggleButton,
  MuiTooltip,
  MuiTreeItem,
  MuiTypography,
  MuiDataGrid,
  MuiTable,
  MuiTableBody,
  MuiTableCell,
  MuiTableContainer,
  MuiTableFooter,
  MuiTableHead,
  MuiTableRow,
  MuiTablePagination,
  MuiTableSortLabel,
  // The Omui* entries below date from the theme2 migration. Don't add new ones: styling a new omui
  // component here splits it across two files for no benefit, so keep it inline in the component.
  OmuiChipWithActionButton,
  OmuiCountBadge,
  OmuiNumberStepper,
  OmuiSegmentedControl,
  OmuiStatusBar,
}
